import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ADD_CHARGE_ACCOUNT_FORM_STEPS, ROLES_NAMES, SCOPE_TYPE, INVITATION_TYPE, DISCOUNT_TYPE } from "../../../../../enums/Enums";
import { DEFAULT_DIALING_CODE } from "../../../../../constants/Constants";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Strings from "../../../../../resources/Strings";
import Icons from "../../../../../resources/icons/Icons";
import * as actionsService from "../../../../../services/ActionsService/ActionsService";
import { userActions } from "../../../../../redux/reducers/UserReducer";
import { getChargeAccountsData, getCurrentSites, getSiteByScopeId } from "../../../../../utils/UsersUtils";
import {
  showErrorMessage,
  showUpdateSuccessMessage,
  showInviteSuccessMessage
} from "../../../../../utils/MessagesUtils";
import { phoneNumberToSend, removePhoneNumberPrefix } from "../../../../../utils/CommonUtils";
import EllipseButton from "../../../Buttons/EllipseButton/EllipseButton";
import classes from "../WizardForm.module.css";
import AddChargeAccountStep from "../Steps/AddChargeAccountStep";
import { ChargeAccountInvitationEntity } from "../../../../../entities/ServicesEntities/UserEntities/ChargeAccountInvitationEntity";
import { UserAdditionalData } from "../../../../../entities/ServicesEntities/UserEntities/UserAdditionalData";
import { UtronUserEntity } from "../../../../../entities/ServicesEntities/UserEntities/UtronUserEntity";
import { UserIdentityEntity } from "../../../../../entities/ServicesEntities/UserEntities/UserIdentityEntity";
import { FullUserEntity } from "../../../../../entities/ServicesEntities/UserEntities/FullUserEntity";
import { UpdateChargeAccountEntity } from "../../../../../entities/ServicesEntities/UserEntities/UpdateChargeAccountEntity";
import { ChargeAccountDataEntity } from "../../../../../entities/ServicesEntities/UserEntities/ChargeAccountDataEntity";

const AddChargeAccountForm = (props) => {
  const currentGmtUser = useSelector((state) => state.user.gmtUser);
  const currentChargeAccounts = useSelector((state) => state.user.currentChargeAccounts);
  const currentUsersScopes = useSelector(
    (state) => state.user.currentUsersScopes
  ); // added
  const sites = useSelector((state) => state.user?.sites); // added
  const roles = useSelector((state) => state.user.initialState.roles);
  const selectedSites = useSelector((state) => state.user.selectedSites);
  const [sitesData, setSitesData] = useState([]); // added
  
  const currentSites = getCurrentSites(sites, currentUsersScopes?.filter(scope => scope?.type === SCOPE_TYPE.PROJECT));
  const allowedTransientsScopesList = currentUsersScopes.filter(scope => currentSites.filter(cs => cs.isAllowedForTransients).some(cs => cs.scopeId === scope.id));

  const [formData, setFormData] = useState({
    chargeAccountName: props?.isEditMode ? props?.utronUser?.chargeAccount?.name : "",
    email: props?.isEditMode ? props?.email : "",
    contactFirstName: props?.isEditMode ? props?.utronUser?.firstName :"",
    contactLastName: props?.isEditMode ? props?.utronUser?.lastName : "",
    dialingCode: DEFAULT_DIALING_CODE,
    phoneNumber: props?.isEditMode ? removePhoneNumberPrefix(props?.phoneNumber) : "",

    // validations
    isFullValidation: props?.isEditMode ? props?.utronUser?.chargeAccountData?.isFullValidation : false,
    discountType: props?.isEditMode ? props?.utronUser?.chargeAccountData?.discountType : DISCOUNT_TYPE.CURRENCY,
    amount: props?.isEditMode ? props?.utronUser?.chargeAccountData?.amount : "",
    notes: props?.isEditMode ? props?.utronUser?.userAdditionalData?.length > 0 && props?.utronUser?.userAdditionalData[0]?.notes : "",

    // scopesList - edit mode - sort - moves the user's current account scope to the top
    scopesList: props?.isEditMode ? allowedTransientsScopesList.sort((a, b) => (b.id === props?.userScopes[0]?.scope?.id) - (a.id === props?.userScopes[0]?.scope?.id)) : allowedTransientsScopesList,
    role: roles.find(role => role.name === ROLES_NAMES.CHARGE_ACCOUNT)?.id,
    scope: allowedTransientsScopesList?.length > 0 ? allowedTransientsScopesList[0].id : "", //currentUsersScopes?.length > 0 ? currentUsersScopes[0].id : "",
    site: allowedTransientsScopesList?.length > 0 ? allowedTransientsScopesList[0] : {}, //currentUsersScopes?.length > 0 ? currentUsersScopes[0] : {},
    sites: sites,
    selectedSite: getSiteByScopeId(sites, allowedTransientsScopesList?.length > 0 ? allowedTransientsScopesList[0].id : "") //getSiteByScopeId(sites, currentUsersScopes?.length > 0 ? currentUsersScopes[0].id : "")
  });


  // added - check for every scope its sites to show for select input
  useEffect(() => {
    let sitesDataToUpdate = [];
    currentUsersScopes.forEach((userScope) => {
      let siteData = getSiteByScopeId(sites, userScope.id);
      if (siteData) {
        sitesDataToUpdate.push(siteData);
      }
    });
    setSitesData(sitesDataToUpdate);
  }, [currentUsersScopes]);

  const [stateData, setStateData] = useState({
    currentStep: ADD_CHARGE_ACCOUNT_FORM_STEPS.CREATE_NEW_CHARGE_ACCOUNT,
    totalSteps: 1,
    isCurrentStepValid: false,
  });

  const handleChange = (newProp) => {
    setFormData({ ...formData, ...newProp });
  };

  const handleCurrentStepValidity = (hasError) => {
    setStateData({ ...stateData, isCurrentStepValid: !hasError });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormData({ ...formData, ["isStepSubmitted"]: true });

    if (stateData.isCurrentStepValid) {
      const {
        role,
        site,
        email,
        dialingCode,
        phoneNumber,
        chargeAccountName,
        contactFirstName,
        contactLastName,
        isFullValidation,
        discountType,
        amount,
        notes,
        selectedSite
      } = formData;
      
      const chargeAccountData = new ChargeAccountDataEntity(
          chargeAccountName,
          contactFirstName,
          contactLastName,
          isFullValidation,
          discountType,
          amount,
          notes,
          selectedSite?.id
      );

      const selectedScope = formData.scopesList.find((scope)=>scope.id === site.id); //userData?.scopes.find((scope)=>scope.id === site.id);
      const chargeAccountInvitationEntity = new ChargeAccountInvitationEntity(
          `${currentGmtUser?.utronUser?.firstName} ${currentGmtUser?.utronUser?.lastName}`,
          currentGmtUser?.utronUser?.identityId,
          email,
          dialingCode + phoneNumberToSend(dialingCode, phoneNumber),
          selectedScope?.id,
          role,
          selectedScope?.name,
          INVITATION_TYPE.CHARGE_ACCOUNT,
          chargeAccountData
          
      );

      if (!props?.isEditMode) {
        actionsService.inviteChargeAccount(chargeAccountInvitationEntity).then((response) => {
          if (response.data.isSuccess) {
            store.dispatch(commonActions.closeSideModal()); // close only on success
            showInviteSuccessMessage();
          } else {
            showErrorMessage(response.data?.error);
            store.dispatch(commonActions.setIsShowLoadingSpinner(false));
          }
        })
        .catch(error => {          
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));          
        });
      }
      else {
        // update
        let userAdditionalData = {};
        if (props.utronUser?.userAdditionalData.length > 0) {
          // set the existed userAdditionalDate with the new note
          userAdditionalData = { ...props.utronUser.userAdditionalData[0] };
          userAdditionalData.notes = notes; 
        }
        else {
          // create one if userAdditionalData doesn't exist
          userAdditionalData = new UserAdditionalData(0, 0, props.utronUser.id, null, null, notes); 
        }

        const utronUser = new UtronUserEntity(
          props.utronUser.id,
          props.id,
          contactFirstName,
          contactLastName,
          null, 
          null,
          null,
          null,
          [userAdditionalData] 
        );

        const userIdentity = new UserIdentityEntity(
          props.id,
          email,
          email,
          dialingCode + phoneNumberToSend(dialingCode, phoneNumber)
        );

        const userToUpdate = new FullUserEntity(
          utronUser,
          userIdentity
        );

        const chargeAccountData = new ChargeAccountDataEntity(
          chargeAccountName,
          contactFirstName,
          contactLastName,
          isFullValidation,
          discountType,
          amount,
          notes,
          selectedSite?.id
        );

        const updateChargeAccount = new UpdateChargeAccountEntity(
          userToUpdate,
          chargeAccountData
        );

        actionsService.updateChargeAccountUser(updateChargeAccount)
        .then(response => {
          if (response.data.isSuccess) {
            let updatedChargeAccountUser = response.data;
            store.dispatch(commonActions.closeSideModal());
            let chargeAccountsIds = currentChargeAccounts?.map(acc => acc?.utronUser?.id);

            actionsService.getChargeAccountsData(chargeAccountsIds, true, true)
            .then(response => {
              let updatedChargeAccounts = getChargeAccountsData(currentChargeAccounts, response.data.entity);
              store.dispatch(userActions.setCurrentChargeAccounts(updatedChargeAccounts));
              store.dispatch(userActions.setUpdatedChargeAccount(updatedChargeAccountUser));
              showUpdateSuccessMessage();
            })
            .catch(error => {
              store.dispatch(commonActions.setIsShowLoadingSpinner(false));
            });
          }
          else {
            showErrorMessage(response.data?.error);
            store.dispatch(commonActions.setIsShowLoadingSpinner(false));
          }
        })
        .catch(error => {
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));          
        });
      }
    }
  };

  return (
    <form name="AddChargeAccountForm" onSubmit={handleSubmit}>
      <div className={classes.formContainer}>
        <div className={classes.stepContainer}>
          <div className={classes.stepTitle}>
            {Strings.STEPS_TITLES.GENERAL_DETAILS_TITLE}
          </div>
          <AddChargeAccountStep 
            isEditMode={props?.isEditMode}
            currentStep={stateData.currentStep}
            handleChange={handleChange}
            handleCurrentStepValidity={handleCurrentStepValidity}
            sitesData={sitesData} // added
            {...formData}
          />
        </div>
        <div className={classes.next}>
          <EllipseButton type="submit">{Strings.SAVE}</EllipseButton>
        </div>
      </div>
    </form>
  );
};

export default AddChargeAccountForm;